import { computed, toValue, type MaybeRefOrGetter } from 'vue';

export type AppSwitcherItem = {
    id: string | number;
    name: string;
    description?: string;
    logo: string;
    href?: string;
    disabled?: boolean;
};

type UseAppSwitcherOptions = {
    apps: MaybeRefOrGetter<AppSwitcherItem[]>;
    currentAppId?: MaybeRefOrGetter<string | number | null | undefined>;
    onSelect?: (app: AppSwitcherItem) => void;
};

export const useAppSwitcher = ({
    apps: appsSource,
    currentAppId: currentAppIdSource,
    onSelect
}: UseAppSwitcherOptions) => {
    const apps = computed(() => toValue(appsSource) ?? []);
    const externalCurrentAppId = computed(
        () => toValue(currentAppIdSource) ?? null
    );

    const currentApp = computed(() => {
        if (!apps.value.length) return null;

        if (externalCurrentAppId.value != null) {
            return (
                apps.value.find(
                    (item) => item.id === externalCurrentAppId.value
                ) ?? apps.value[0]
            );
        }

        return apps.value[0];
    });

    const currentAppId = computed(() => currentApp.value?.id ?? null);

    const onSelectApp = (app: AppSwitcherItem) => {
        if (app.disabled) return;
        onSelect?.(app);
    };

    return {
        apps,
        currentApp,
        currentAppId,
        onSelectApp
    };
};
